import * as React from 'react';
import styled from 'styled-components';

import { getColor, getFontSize } from '@process-advisor/process-miner/shared/theme';
import {
    ColorPickerContext,
    type ColorPickerContextType,
} from '@process-advisor/process-miner/shared/providers/colorPickerProvider';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Label = styled.div`
    font-size: ${getFontSize('smaller')};
    color: ${getColor('darkFontColor')};
`;

const Preview = styled.div<{ color: string }>`
    cursor: pointer;
    background-color: ${({ color }) => color};
    margin: 5px;
    border-radius: 2px;
    width: 16px;
    height: 16px;
`;

type Props = {
    id: string;
    onColorChange: (val: string) => void;
    label?: string;
    color: string;
    className?: string;
    onClose?: () => void;
}

export const ColorInput: React.FC<Props> = ({
    id,
    onColorChange,
    label,
    color,
    className,
    onClose,
}) => {
    const inputRef = React.useRef<HTMLDivElement>(null);
    const {
        props,
        setProps,
    } = React.useContext<ColorPickerContextType>(ColorPickerContext);
    const [stateColor, setStateColor] = React.useState<string>(color);

    const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
        const { x, y } = inputRef.current.getBoundingClientRect();
        setProps({ x, y, show: true, color: stateColor, id, onClose });
        e.stopPropagation();
    };

    React.useEffect(() => {
        if (props.id === id && props.color !== stateColor) {
            setStateColor(props.color);
            onColorChange(props.color);
        }
    }, [id, onColorChange, props, stateColor]);

    React.useEffect(() => {
        setStateColor(color);
    }, [color]);

    return (
        <Wrapper
            ref={inputRef}
            className={className}
            onClick={handleOnClick}>
            { label && <Label>{label}</Label> }
            <Preview color={stateColor} />
        </Wrapper>
    );
};
